// extracted by mini-css-extract-plugin
module.exports = {"wrap":"TaskDetailsContainer_wrap__2viEs","wrapNote":"TaskDetailsContainer_wrapNote__1OKZY","groupDetails":"TaskDetailsContainer_groupDetails__ksAj-"};